export default "__VITE_ASSET__cY3J9GSd__"